var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08398 4.94637H10.9173V6.7797H9.08398V4.94637ZM9.08398 8.61304H10.9173V14.113H9.08398V8.61304ZM10.0007 0.363037C4.94065 0.363037 0.833984 4.4697 0.833984 9.5297C0.833984 14.5897 4.94065 18.6964 10.0007 18.6964C15.0607 18.6964 19.1673 14.5897 19.1673 9.5297C19.1673 4.4697 15.0607 0.363037 10.0007 0.363037ZM10.0007 16.863C5.95815 16.863 2.66732 13.5722 2.66732 9.5297C2.66732 5.4872 5.95815 2.19637 10.0007 2.19637C14.0431 2.19637 17.334 5.4872 17.334 9.5297C17.334 13.5722 14.0431 16.863 10.0007 16.863Z",
    fill: "#0288D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.cda853490c7e138bd7eea06cbf788934.svg";
export { ForwardRef as ReactComponent };